var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.ref,staticClass:"dv-scroll-board"},[(_vm.mergedConfig)?_c('div',{staticClass:"header"},_vm._l((_vm.mergedConfig.header),function(headerItem,i){return _c('div',{key:headerItem + i,staticClass:"header-item",style:(`
        height: ${_vm.mergedConfig.headerHeight}px;
        line-height: ${_vm.mergedConfig.headerHeight}px;
        width: ${_vm.mergedConfig.columnWidth[i]}px;
        padding-left:${_vm.mergedConfig.columnPaddingLeft[i]}px;
        font-size: ${_vm.mergedConfig.headerFontSize}px;
      `),attrs:{"align":_vm.aligns[i]}},[_vm._v(" "+_vm._s(headerItem)+" ")])}),0):_vm._e(),(_vm.mergedConfig)?_c('div',{staticClass:"rows",style:({
      height: `${_vm.height -
        (_vm.header.length ? _vm.mergedConfig.headerHeight : 0) -
        _vm.mergedConfig.columnMarginTop}px`,
      marginTop: `${_vm.mergedConfig.columnMarginTop}px`,
      marginRight: `${_vm.mergedConfig.columnMarginRight}px`
    })},_vm._l((_vm.rows),function(row,ri){return _c('div',{key:row.toString() + row.scroll,staticClass:"row-item",class:ri % 2 !== 0 ? 'card-bg-2' : '',style:(`
        height: 20px;
        line-height: 20px;
        fontSize: ${_vm.mergedConfig.columnFontSize}px;
      `)},_vm._l((row.ceils),function(ceil,ci){return _c('div',{key:ceil + ri + ci,staticClass:"ceil",style:(`
        width: ${_vm.mergedConfig.columnWidth[ci]}px;
        padding-left:${_vm.mergedConfig.columnPaddingLeft[ci]}px;
      `),attrs:{"align":_vm.aligns[ci]}},[(typeof(ceil) == 'number')?_c('countTo',{key:_vm.componentKey,attrs:{"startVal":0,"endVal":ceil,"duration":2000}}):_c('span',[_vm._v(" "+_vm._s(ceil)+" ")])],1)}),0)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }